module.exports = __webpack_public_path__ + "static/media/md-close-circle.5ecf73b4.svg";